import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5701%3A11770
 *
 * @param {SvgIconProps} props - svg props
 */
export const CopyIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M8 4C8 2.34315 9.34315 1 11 1H15.5724C16.1607 1 16.7192 1.25901 17.0992 1.70812L21.5268 6.94073C21.8323 7.30184 22 7.75957 22 8.23262V16.5001C22 18.157 20.6569 19.5001 19 19.5001H11C9.34315 19.5001 8 18.157 8 16.5001V4Z' fill={color}/>
            <path d='M9.5 4C9.5 3.17157 10.1716 2.5 11 2.5H14.5784C15.4782 2.5 16.3304 2.90388 16.9002 3.60029L19.8219 7.17118C20.2604 7.70716 20.5 8.37836 20.5 9.07089V16.5C20.5 17.3284 19.8284 18 19 18H11C10.1716 18 9.5 17.3284 9.5 16.5V4Z' fill='white'/>
            <path d='M15.5049 2.5L15.5049 5.9984C15.505 7.10359 16.4014 8 17.5066 8H21.5001' stroke={color} strokeWidth='1.5'/>
            <path d='M2 7.5C2 5.84315 3.34315 4.5 5 4.5H9.5724C10.1607 4.5 10.7192 4.75901 11.0992 5.20812L15.5268 10.4407C15.8323 10.8018 16 11.2596 16 11.7326V20.0001C16 21.657 14.6569 23.0001 13 23.0001H5C3.34315 23.0001 2 21.657 2 20.0001V7.5Z' fill={color}/>
            <path d='M3.5 7.5C3.5 6.67157 4.17157 6 5 6H8.57836C9.47816 6 10.3304 6.40388 10.9002 7.10029L13.8219 10.6712C14.2604 11.2072 14.5 11.8784 14.5 12.5709V20C14.5 20.8284 13.8284 21.5 13 21.5H5C4.17157 21.5 3.5 20.8284 3.5 20V7.5Z' fill='white'/>
            <path d='M9.50489 6L9.50494 9.4984C9.50496 10.6036 10.4014 11.5 11.5066 11.5H15.5001' stroke={color} strokeWidth='1.5'/>
        </SvgIcon>
    )
}

export default CopyIcon
